<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-unavailable-multi-delete
		[formControl]="control"
		rpsharedRemoveHost
	></rpshared-unavailable-multi-delete>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="primary">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid"
			color="warn"
			[mat-dialog-close]="group"
		>
			Delete
		</button>
	</div>
</div>
